<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .single-choice-mapping-row {
    display: grid;
    grid-template-columns:
      utils.in_rem(200px)
      utils.in_rem(59px)
      auto
      utils.in_rem(59px)
      auto;
    align-items: center;

    .header {
      @include mixins.h2();
    }

    .field-name {
      @include mixins.body2();
    }

    .input-field {
      display: flex;
      align-items: center;
      gap: utils.in_rem(16px);
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import InfoIcon from "../InfoIcon.svelte";

  import { integrationStore } from "../../../stores";

  export let header;
  export let sourceLabel;
  export let targetLabel;

  export let setting = {};
  export let type;
  export let disabled = false;

  $: storeValue = $integrationStore.getValue(setting.key, type);

  $: selected = storeValue;

  $: items =
    setting.values
      ?.filter(
        (item) =>
          !type ||
          !item.syncAsRestrictions ||
          item.syncAsRestrictions.includes(
            type.charAt(0).toUpperCase() + type.slice(1)
          )
      )
      ?.map((item) => ({
        id: item.val,
        value: item.val,
        label: item.key,
      })) || [];

  $: if (selected !== storeValue) {
    $integrationStore.setValue(setting.key, selected, type);
  }

  $: dropdownProps = {
    style: "width:240px",
    kind: "input-field",
    size: "large",
    disabled,
  };
</script>

<div class="single-choice-mapping-row">
  {#if header}
    <div class="header">{sourceLabel}</div>
    <Icon class="fas fa-arrow-right" />
    <div class="header">{targetLabel}</div>
  {:else}
    <div class="field-name">{setting.title}</div>
    <Icon class="fas fa-arrow-right" />
    <div class="input-field">
      {#if disabled}
        <Dropdown {...dropdownProps}>
          <span slot="tooltip">
            Select {setting.title} in note creation to apply note mapping
          </span>
          <span slot="button"> No note </span>
        </Dropdown>
      {:else}
        <SingleSelectDropdown
          style="width:240px"
          size="large"
          {items}
          bind:selected
          placeholder="Select"
          showFilter={false}
          showDescription={true}
          restrictHeight={true}
        />
      {/if}
      {#if setting.info}
        <InfoIcon>{setting.info}</InfoIcon>
      {/if}
    </div>
  {/if}
</div>
